module.exports = __webpack_public_path__ + "img/phone.a3cb9afa.svg";